<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="merchandise"
          :title="title"
          :url="url"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        ></datatable>
      </div>
    </div>
    <form-action ref="form" module="merchandise" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="merchandise"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormAction from "./Form";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Stock Merchandise", route: "" },
      { title: "Merchandise" }
    ]);
  },
  data() {
    return {
      title: "Merchandise",
      url: "merchandise/data",
      columns: [
        {
          value: "id"
        },
        {
          text: "Slug",
          value: "slug",
          sortable: true,
          searchable: true
        },
        {
          text: "Nama",
          value: "name",
          sortable: true,
          searchable: true
        },
        {
          text: "Unit",
          value: "unit",
          sortable: true,
          searchable: true
        },
        {
          text: "Total Stok",
          value: "total_stock",
          sortable: true,
          searchable: false
        },
        {
          text: "Total Merchandise Restock",
          value: "total_in",
          sortable: true,
          searchable: false
        },
        {
          text: "Total Merchandise Keluar",
          value: "total_out",
          sortable: true,
          searchable: false
        }
      ]
    };
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    }
  },
  components: {
    Datatable,
    DeleteDialog,
    FormAction
  }
};
</script>
